import { useState } from "react";
import { Upload, message } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  // const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  // if (!isJpgOrPng) {
  //   message.error("You can only upload JPG/PNG file!");
  // }
  const isLt2M = file.size / 1024 / 1024 < 50;
  if (!isLt2M) {
    message.error("Image must smaller than 50MB!");
  }
  // return isJpgOrPng && isLt2M;
  return isLt2M;
}

export default function SingleUpload({
  value,
  onChange = () => {},
  setFileList = () => {},
  hideText = false,
  typeCheck = true,
  hideResult = false,
  // When true, emit the full upload response object ({ url, filetype, ... })
  // instead of just the url string. Needed by callers that persist filetype.
  returnResponse = false,
}) {
  const [loading, toggleLoading] = useState(false);

  const handleChange = (info) => {
    if (info.file.status === "uploading") {
      toggleLoading(true);

      return;
    }
    if (info.file.status === "done") {
      const response = info.fileList[0].response;
      getBase64(info.file.originFileObj, () => {
        toggleLoading(false);

        onChange(returnResponse ? response : response?.url);
        setFileList((prev) => [...prev, info.fileList[0]]);
      });
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      {!hideText && <div style={{ marginTop: 8 }}>Upload</div>}
    </div>
  );
  return (
    <>
      {/* {showImagePickerModel ? (
        <div
          className={hideText ? "small-upload" : ""}
          onClick={() => setShowImageModal(true)}
          style={{
            height: hideText ? 32 : 100,
            width: hideText ? 40 : 100,
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "#fafafa",
            border: "1px dashed #d9d9d9",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          {value ? (
            <img src={value} alt="avatar" style={{ width: "100%" }} />
          ) : (
            <>
              <PlusOutlined />
              {!hideText && <div style={{ marginTop: 8 }}>Upload</div>}
            </>
          )}
        </div>
      ) : ( */}
      <div className={hideText ? "small-upload" : ""}>
        <Upload
          name="file"
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          maxCount={1}
          action={`${process.env.REACT_APP_API_MEDIA_URL}`}
          beforeUpload={typeCheck ? beforeUpload : undefined}
          headers={{
            Authorization: `${localStorage.getItem("access_token")}`,
          }}
          onChange={handleChange}
          style={{ height: 100, width: 100 }}
        >
          {!hideResult && value ? (
            <img src={value} alt="avatar" style={{ width: "100%" }} />
          ) : (
            uploadButton
          )}
        </Upload>
      </div>

      {/* <ModalPickImage
        visible={showImageModal}
        imageList={fileList}
        handleClose={handleImageSelect}
        beforeImageUpload={beforeUpload}
        handleImageChange={handleChange}
        loading={loading}
      /> */}
    </>
  );
}
